import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: '[br-toggle]',
    templateUrl: './br-toggle.component.html',
    styles: [`
        .br-popover-full-width {

            padding:10px;
            color: #000;
            background: #fff;
            border:1px solid #bab8b8;
            font-size: 14px;

            position: absolute;
            z-index:10;
            width: 95%;

            box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -moz-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -webkit-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -o-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);

            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            border-radius: 5px;
        }

        .br-popover-full-width-trigger {
            position: relative;
            display: inline-block;
            padding-bottom: 8px;
        }

        span.caretup {
            position: absolute;
            bottom: -2px;
            left: 4px;
            z-index:11;

            display: inline-block;
            width: 0;
            height: 0;
            vertical-align: middle;
            border-bottom: 10px solid #fff;
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            content: "";
         }

         span.caretup-out {
            position: absolute;
            bottom: -2px;
            left: 2px;
            z-index:10;

            display: inline-block;
            width: 0;
            height: 0;
            vertical-align: middle;
            border-bottom: 12px solid #bab8b8;
            border-right: 12px solid transparent;
            border-left: 12px solid transparent;
            border-opacity: 0.5;
            content: "";
         }

         .br-popover-small {
          width: 200px;
        }

        .br-popover-medium {
          width: 450px;
        }

        .br-popover-large {
            padding:10px;
            color: #000;
            background: #fff;
            border:1px solid #bab8b8;
            font-size: 14px;

            position: absolute;
            z-index:100000;
            top:20px;
            left: -400px;
            width:700px;

            box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -moz-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -webkit-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
            -o-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);

            -moz-border-radius: 5px;
            -webkit-border-radius: 5px;
            border-radius: 5px;
        }

        .br-popover-x-large {
            width: 1000px;
        }

        :host >>> .br-toggle {
          color: #000 !important;
          max-width: none !important;
          z-index: 100001;
          box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
          -moz-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
          -webkit-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
          -o-box-shadow: 0px 2px 2px rgba(0,0,0,0.4);
        }

        :host >>> .br-toggle.popover.bs-tether-element-attached-top::before, 
        :host >>> .br-toggle.popover.popover-bottom::before {
          border-bottom: 0;
        }

        :host >>> .br-toggle.right .arrow {
            left: 28px !important;
        }

        :host >>> .br-toggle.right {
          left: -20px !important;
        }
    `]
})
export class BrToggleComponent implements OnInit {

    fullWidth:boolean = false;

    @Input() size: string = 'br-popover-medium';
    @Input() display: string = 'right';

    containerClass: string = 'br-toggle';

    ngOnInit() {

        if (this.size) {
            switch (this.size) {
                case 'x-large':
                    this.size = 'br-popover-x-large';
                    break;
                case 'large':
                    this.size = 'br-popover-large';
                    break;
                case 'medium':
                    this.size = 'br-popover-medium';
                    break;
                case 'small':
                    this.size = 'br-popover-small';
                    break;
            }
        }

        switch (this.display) {
            case 'full-width':
                this.fullWidth = true;
            break;
            case 'right':
                this.containerClass += ' right';
            break;
            default:
                this.containerClass += ' default';
            break;
        }

    }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-toggle/br-toggle.component.ts